(() => {
  'use strict';

  /** @param {HTMLElement} sectionEl */
  const initSwiper = (sectionEl) => {
    const swiperEl = /** @type {HTMLElement | null} */ (sectionEl.querySelector('.cpr-swiper'));
    if (!swiperEl || swiperEl.dataset.cprSwiperInit) return;
    if (typeof window.Swiper === 'undefined') return;

    swiperEl.dataset.cprSwiperInit = '1';

    new window.Swiper(swiperEl, {
      slidesPerView: 'auto',
      spaceBetween: 16,
      pagination: {
        el: sectionEl.querySelector('.cpr-pagination'),
        clickable: true,
      },
      navigation: {
        prevEl: sectionEl.querySelector('.cpr-swiper-prev'),
        nextEl: sectionEl.querySelector('.cpr-swiper-next'),
      },
    });
  };

  /** @param {HTMLElement} sectionEl */
  const observeSection = (sectionEl) => {
    initSwiper(sectionEl);

    const observer = new MutationObserver(() => initSwiper(sectionEl));
    observer.observe(sectionEl, { childList: true, subtree: true });
  };

  const setup = () => {
    document.querySelectorAll('.custom-product-recommendations').forEach(observeSection);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
})();
